import React from "react";
import { Navigate } from "react-router-dom";
import ForgetPassword from "src/pages/Authentication/ForgetPassword";
import Login from "src/pages/Authentication/Login";
import Logout from "src/pages/Authentication/Logout";
import ResetPassword from "src/pages/Authentication/ResetPassword";
import UsersPage from "src/pages/Users";
import Error404 from "src/pages/Authentication/Error404";
import Dashboard from "../pages/Dashboard";
import FaqsPage from "src/pages/Web-Faqs";
import MarketingV2Page from "src/pages/MarketingV2";
import PackagePage from "src/pages/Web-Packages";
import SpesificationsPage from "src/pages/Web-Spesifications";
import HowToUsePage from "src/pages/Web-Howtouse";
import CalllogStatusPage from "src/pages/Clients-CallogStatuses";
import ExtraServicePage from "src/pages/ExtraServices";
import ExtraServiceGroupPage from "src/pages/ExtraServices-Groups";
import FileTypePage from "src/pages/FileTypes";
import ReminderSubjectsPage from "src/pages/ReminderSubjects";
import FinancialAccountTypePage from "src/pages/FinancialAccount-Types";
import TaxPage from "src/pages/Tax";
import PaymentProviderPage from "src/pages/PaymentProvider";
import MaintenanceStatusPage from "src/pages/Maintenance-Status";
import MaintenanceTypePage from "src/pages/Maintenance-Types";
import SupplierTypePage from "src/pages/Maintenance-SupplierTypes";
import TicketPage from "src/pages/Ticket";
import AssetFeatureOptionPage from "src/pages/Asset-Feature-Options";
import AssetFeaturePage from "src/pages/Asset-Features";
import AssetTypePage from "src/pages/Asset-Types";
import BrandPage from "src/pages/Asset-Brands";
import AssetGroupPage from "src/pages/Asset-Groups";
import OfficeGroupPage from "src/pages/Office-Groups";
import SectorPage from "src/pages/Sectors";
import UygunaKiralaLocationPage from "src/pages/UygunaKiralaLocations";
import SubBrandPage from "src/pages/Asset-BrandSubs";
import ContactPage from "src/pages/Contacts";
import ContractStatusesPage from "src/pages/Contract-Statuses";
import ContractAssetStatusesPage from "src/pages/Contract-Asset-Statuses";
import ContractSourcesPage from "src/pages/Contract-Sources";
import ContractTypeesPage from "src/pages/Contract-Types";
import ContractTransactionTypesPage from "src/pages/Contract-Transaction-Types";
import DiscountPlanesPage from "src/pages/Contract-DiscountPlans";
import ContractDamageDefinitionsPage from "src/pages/Contract-Damage";
import ContractCancellationReasonsPage from "src/pages/Contract-CancellationReason";
import ContractDeliveryRefundDefinitionsPage from "src/pages/Contract-PickupDropOff";
import DamageOptionsPage from "src/pages/Contract-Damage-Picklist";
import DeliveryOptionsPage from "src/pages/Contract-PickupDropOff-Picklist";
import ClientOnboardingPage from "src/pages/Client-Onboardings";
import OntologyPage from "src/pages/Ontology";
import SystemStatusPage from "src/pages/System-Status";
import TrustPage from "src/pages/Trust";
import ClientPage from "src/pages/Clients";
import ClientDetailPage from "src/pages/Clients-Details";
import AgreementsPage from "src/pages/Agreements";
import LegalPage from "src/pages/Legal";
import AppTutorialsPage from "src/pages/Tutorials";
import AppTutorialVideosPage from "src/pages/Tutorials/videos";
import SubscriptionsPage from "src/pages/Subscriptions";
import EmailSettingsPage from "src/pages/EmailSettings";
import MailProvisioningPage from "src/pages/MailProvisioning";
import TestimonialPage from "src/pages/Testimonials";
import ClientCancellationReasonPage from "src/pages/ClientCancellationReasons";
import BankAccountPage from "src/pages/BankAccounts";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
  permission?: string[];
}

const userRoutes: Array<RouteProps> = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/payment-provider", component: <PaymentProviderPage /> },
  { path: "/testimonials", component: <TestimonialPage /> },
  { path: "/bankaccounts", component: <BankAccountPage /> },

  { path: "/agreements", component: <AgreementsPage /> },
  { path: "/legal-documents", component: <LegalPage /> },
  { path: "/tutorials", component: <AppTutorialsPage /> },
  { path: "/tutorials/videos/:playlistId", component: <AppTutorialVideosPage /> },
  { path: "/subscriptions", component: <SubscriptionsPage /> },
  { path: "/email-settings", component: <EmailSettingsPage /> },
  { path: "/mail-provisioning", component: <MailProvisioningPage /> },
  //Client
  { path: "/calllog-status", component: <CalllogStatusPage /> },
  { path: "/clients", component: <ClientPage /> },
  // V2 Faz E — tedarikçi onboarding kuyruğu (Ai portalının yerini alır)
  { path: "/client-onboardings", component: <ClientOnboardingPage /> },
  // V2 Faz F — ontoloji yönetimi (Ai yönetim yüzeyinin yerini alır)
  { path: "/ontology", component: <OntologyPage /> },
  // V2 Faz F — güven/risk operasyonu (Ai admin-panel yerine)
  { path: "/trust", component: <TrustPage /> },
  // V2 Faz F — sistem durumu (Ai admin-panel yerine)
  { path: "/system-status", component: <SystemStatusPage /> },
  {
    path: "/clients/cancellation-reasons",
    component: <ClientCancellationReasonPage />,
  },
  { path: "/clients/details/:tab/:id", component: <ClientDetailPage /> },

  //Ticket
  {
    path: "/ticket/:tab",
    component: <TicketPage />,
  },

  //Maintenance
  { path: "/maintenance/supplier-types", component: <SupplierTypePage /> },
  { path: "/maintenance/statuses", component: <MaintenanceStatusPage /> },
  { path: "/maintenance/types", component: <MaintenanceTypePage /> },

  //EXTRA SERVICE
  { path: "/extra-services", component: <ExtraServicePage /> },
  { path: "/extra-services/groups", component: <ExtraServiceGroupPage /> },

  //WEB
  { path: "/web/marketing-v2", component: <MarketingV2Page /> },
  { path: "/web/faqs", component: <FaqsPage /> },
  { path: "/web/packages", component: <PackagePage /> },
  { path: "/web/spesifications", component: <SpesificationsPage /> },
  { path: "/web/howtouses", component: <HowToUsePage /> },

  //ASSET
  { path: "/asset/types", component: <AssetTypePage /> },
  { path: "/asset/brands", component: <BrandPage /> },
  { path: "/asset/brands/subs/:Id", component: <SubBrandPage /> },
  { path: "/asset/groups", component: <AssetGroupPage /> },
  { path: "/asset/features", component: <AssetFeaturePage /> },
  {
    path: "/asset/features/options/:featureId",
    component: <AssetFeatureOptionPage />,
  },

  //CONTRACT
  { path: "/contract/statuses", component: <ContractStatusesPage /> },
  {
    path: "/contract/asset-statuses",
    component: <ContractAssetStatusesPage />,
  },
  { path: "/contract/sources", component: <ContractSourcesPage /> },
  { path: "/contract/types", component: <ContractTypeesPage /> },
  {
    path: "/contract/transaction-types",
    component: <ContractTransactionTypesPage />,
  },
  {
    path: "/contract/cancellation-reasons",
    component: <ContractCancellationReasonsPage />,
  },
  { path: "/contract/discount-plans", component: <DiscountPlanesPage /> },
  {
    path: "/contract/damage-definitions",
    component: <ContractDamageDefinitionsPage />,
  },
  {
    path: "/contract/damage-definitions/picklist/:id",
    component: <DamageOptionsPage />,
  },
  {
    path: "/contract/pickup-dropoff-definitions",
    component: <ContractDeliveryRefundDefinitionsPage />,
  },
  {
    path: "/contract/pickup-dropoff-definitions/picklist/:id",
    component: <DeliveryOptionsPage />,
  },

  //SETTINGS
  { path: "/users", component: <UsersPage /> },
  //WEB
  { path: "/office-groups", component: <OfficeGroupPage /> },
  { path: "/sectors", component: <SectorPage /> },
  { path: "/file-types", component: <FileTypePage /> },
  { path: "/reminder-subjects", component: <ReminderSubjectsPage /> },
  { path: "/contacts", component: <ContactPage /> },
  { path: "/financial-account-types", component: <FinancialAccountTypePage /> },
  {
    path: "/uyguna-kirala/locations",
    component: <UygunaKiralaLocationPage />,
  },
  { path: "/taxes", component: <TaxPage /> },

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: "/404", component: <Error404 /> },
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  { path: "/reset-password", component: <ResetPassword /> },
];

export { userRoutes, authRoutes };
